import { render, staticRenderFns } from "./NotesFiltering.vue?vue&type=template&id=4bb13c74&"
import script from "./NotesFiltering.vue?vue&type=script&lang=js&"
export * from "./NotesFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports